import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultAwardModel = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as AwardEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<AwardEditCriteria>,
}

export interface AwardEditCriteria {
  award_Id: number;

  apexId: string;
  driverName: string;
  driver_Id: string;
  awardName: string;
  awardDate: string;
}
